<script lang="ts">
  import TopBlock from "./components/TopBlock.svelte";
  import TwoColumns from "../TwoColumns.svelte";
  import SchedulePanel from "../../blocks/schedule-panel/SchedulePanel.svelte";
  import type { ISchedulePanel } from "../../blocks/schedule-panel/SchedulePanel.svelte";
  import StatusPanel from "../../blocks/status-panel/StatusPanel.svelte";
  import type { IStatusPanel } from "../../blocks/status-panel/StatusPanel.svelte";
  import type { IPageData } from "../../../core/types";
  import type {
    documentsBlockType,
    myProfileBlockType,
  } from "./components/TopBlock.svelte";
  import Impersonation from "./components/Impersonation.svelte";
  import { QuestionnaireBlockType, userInfo } from "../../layouts/header/user/user-store";
  import { onDestroy } from 'svelte';

  interface IHomePage extends IPageData {
    myProfileBlock: myProfileBlockType;
    documentsBlock: documentsBlockType;
    schedulePanel: ISchedulePanel;
    statusPanel: IStatusPanel;
  }

  export let data: IHomePage;
</script>

<TwoColumns>
  <div class="desk-top-block">
    <TopBlock
      documentsBlock={data.documentsBlock}
      myProfileBlock={data.myProfileBlock}
    />
  </div>

  <slot />

  <div slot="aside">
    <div class="mobile-top-block">
      <TopBlock
        documentsBlock={data.documentsBlock}
        myProfileBlock={data.myProfileBlock}
      />
    </div>
    <div class="g-centered">
      <SchedulePanel schedulePanel={data.schedulePanel} />
      <StatusPanel statusPanel={data.statusPanel} />

      {#if $userInfo !== null && $userInfo.isImpersonationAllowed}
        <Impersonation />
      {/if}
    </div>
  </div>
</TwoColumns>

<style lang="scss">
  .desk-top-block {
    @include md-show;
  }

  .mobile-top-block {
    @include md-hide;
  }
</style>
